import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import Login from './pages/Login/Login';
import ProductsTable from './pages/Products/ProductsTable';
import Container from './PageContainer';
import Root from './root';
import Signup from './pages/Login/Signup';
import ProductView from './pages/Products/ProductView';
import MerchantsTable from './pages/Merchants/MerchantsTable';
import CreateMerchant from './pages/Merchants/CreateMerchant';
import MerchantView from './pages/Merchants/MerchantView';
import CreateCatalog from './pages/Catalogs/CreateCatalog';
import CatalogView from './pages/Catalogs/CatalogView';
import CreateProduct from './pages/Products/CreateProduct';
import EditProduct from './pages/Products/EditProduct';
import OrganizationsTable from './pages/Organizations/OrganizationsTable';
import CreateOrganization from './pages/Organizations/CreateOrganization';
import BrandsTable from './pages/Brands/BrandsTable';
import CreateBrand from './pages/Brands/CreateBrand';
import CatalogAddProducts from './pages/Catalogs/CatalogAddProducts/CatalogAddProducts';
import AddProductsFromList from './pages/Catalogs/CatalogAddProducts/FromList/AddProductsFromList';
import AddProductsFromSpreadsheet from './pages/Catalogs/CatalogAddProducts/FromSpreadsheet/AddProductsFromSpreadsheet';
import AddProductsFromDatabase from './pages/Catalogs/CatalogAddProducts/FromDatabase/AddProductsFromDatabase';
import CatalogCheckoutComplete from './pages/Catalogs/CatalogCheckoutComplete';
import AddProductsFromCatalog from './pages/Catalogs/CatalogAddProducts/FromCatalog/AddProductFromCatalog';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Root />}>
      <Route path="/login/*" element={<Login />} />
      <Route path="/signup/*" element={<Signup />} />
      <Route path="/" element={<Container />}>
        <Route path="products/*" element={<ProductsTable />} />
        <Route path="products/:orgId/create" element={<CreateProduct />} />
        <Route path="organizations/*" element={<OrganizationsTable />} />
        <Route path="organizations/create" element={<CreateOrganization />} />
        <Route path="brands/*" element={<BrandsTable />} />
        <Route path="brands/:orgId/create" element={<CreateBrand />} />
        <Route path="products/:orgId" element={<ProductsTable />} />
        <Route path="products/:orgId/:productId" element={<ProductView />} />
        <Route
          path="products/:orgId/:productId/edit"
          element={<EditProduct />}
        />
        <Route path="merchants" element={<MerchantsTable />} />
        <Route path="merchants/create" element={<CreateMerchant />} />
        <Route path="merchants/:merchantId" element={<MerchantView />} />
        <Route
          path="merchants/:merchantId/catalogs/create"
          element={<CreateCatalog />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId"
          element={<CatalogView />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/activate"
          element={<CatalogView />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/checkout-complete"
          element={<CatalogCheckoutComplete />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/add-products"
          element={<CatalogAddProducts />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/add-products/spreadsheet"
          element={<AddProductsFromSpreadsheet />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/add-products/list"
          element={<AddProductsFromList />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/add-products/database"
          element={<AddProductsFromDatabase />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/add-products/copy"
          element={<AddProductsFromCatalog />}
        />
        <Route
          path="merchants/:merchantId/catalogs/:catalogId/edit"
          element={<CreateCatalog />}
        />
      </Route>
    </Route>
  )
);

export default router;
